<span class="aud-badge" [class.all]="isEveryone">
    <svg *ngIf="isEveryone" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4">
        <path d="M20 6L9 17l-5-5" />
    </svg>
    <svg *ngIf="!isEveryone" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
        <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
        <circle cx="9" cy="7" r="4" />
    </svg>
    {{ label }}
</span>
